import { connect } from 'react-redux';
import WistiaPlayer from './WistiaPlayer';
import { actions as videoActions } from '../../reducer';

const mapStateToProps = (state) => {
  return {
    playbackRate: state.video.get('playbackRate'),
    playbackVolume: state.video.get('playbackVolume'),
    captionsVisible: state.video.get('captionsVisible'),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPlaybackRate: (rate) => dispatch(videoActions.setPlaybackRate(rate)),
    setPlaybackVolume: (level) =>
      dispatch(videoActions.setPlaybackVolume(level)),
    setCaptionsVisible: (visible) =>
      dispatch(videoActions.setCaptionsVisible(visible)),
    addVideoElement: (videoElement) =>
      dispatch(videoActions.addVideoElement(videoElement)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WistiaPlayer);
